import React, { useState, useEffect, useRef } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import { GoArrowRight } from "react-icons/go";

const LandingPageExplore = ({ scrollY }) => {
  const [offers, setOffers] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  // Fetch offers from Firestore
  useEffect(() => {
    const fetchOffers = async () => {
      const offersRef = collection(db, "offers");
      const querySnapshot = await getDocs(offersRef);
      const offersList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setOffers(offersList);
    };

    fetchOffers();
  }, []);

  // Automatically change slides
  useEffect(() => {
    if (offers.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % offers.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [offers]);

  // Intersection observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        setInView(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const handleClick = (offerId) => {
    navigate(`/OffersPage/${offerId}`);
  };

  return (
    <div
      className="relative w-full h-screen bg-transparent mt-20 overflow-hidden flex flex-col justify-between"
      ref={sectionRef}
    >
      {/* 3D Slider */}
      <div className="relative w-full h-full flex items-center justify-center px-4 m-0">
        {offers.map((offer, index) => {
          const isActive = index === currentIndex;
          const prevIndex = (currentIndex - 1 + offers.length) % offers.length;
          const nextIndex = (currentIndex + 1) % offers.length;

          const position = isActive
            ? "z-20 scale-110 rotate-0"
            : index === prevIndex
            ? "z-10 scale-95 rotate-6 -translate-x-full opacity-70 hidden sm:block"
            : index === nextIndex
            ? "z-10 scale-95 -rotate-6 translate-x-full opacity-70 hidden sm:block"
            : "hidden";

          return (
            <div
              key={index}
              className={`absolute w-[90%] sm:w-[400px] md:w-[500px] lg:w-[600px] h-[250px] sm:h-[400px] md:h-[500px] lg:h-[600px] bg-cover bg-center rounded-2xl shadow-2xl mb-20 transform transition-all duration-700 ${position}`}
              style={{ backgroundImage: `url(${offer.image})` }}
              onClick={() => handleClick(offer.id)}
            >
              {/* Showing details with flex-col and covering the whole image */}
              <div className="absolute inset-0 flex flex-col justify-between border bg-black bg-opacity-50 opacity-0 hover:opacity-100 text-white transition-all duration-700 p-4 rounded-2xl transform translate-y-0 ">
                <div className="flex flex-col justify-center">
                  <h3 className="text-3xl font-semibold mt-4 py-4">{offer.name}</h3>
                  <p className="text-xl mt-4 ">
                    {offer.city}, {offer.country}
                  </p>
                  <p className="text-xl mt-4">
                    <span className="font-bold ">نوع الرحلة : </span>
                    {offer.type}
                  </p>
                </div>
                <button class="relative font-bold text-white overflow-hidden w-min group mt-auto text-5xl hover:-translate-x-4 transition-all duration-500 bg-slate-800 rounded-full p-4 cursor-pointer">
                  <span class="relative z-10"><GoArrowRight/></span>       
                  <div class="absolute top-0 left-1/2 w-0 h-full bg-white opacity-50 rounded-full transition-all duration-150 ease-in-out transform -translate-x-1/2 group-hover:w-[300%] group-hover:opacity-30"></div>
                </button>
                <div className="mt-auto">
                  <p className="text-lg font-bold">
                    دج<span className="text-5xl"> {offer.price}</span>
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Explore All Offers Button */}
      <div className="w-full flex justify-center items-center pb-10">
        <Link to="./OffersPage" c> 
        <button class="relative font-bold text-white overflow-hidden w-min group mt-auto text-5xl hover:translate-x-4 transition-all duration-700 bg-gradient-to-br from-[#047857] to-gray-100 rounded-full p-4 cursor-pointer flex flex-row justify-center items-center">
         <span class="relative z-10"><GoArrowRight/></span> 
         <span className="text-lg w-min px-4 py-2 text-nowrap">
          استكشف كل عروضنا
         </span>
             
          <div class="absolute top-0 left-1/2 w-0 h-full bg-white opacity-50 rounded-full transition-all duration-300 ease-in-out transform -translate-x-1/2 group-hover:w-[300%] group-hover:opacity-30"></div>
        </button>
        </Link> 
      </div>
      
    </div>
  );
};

export default LandingPageExplore;
